<template
  ><Panel title="Chords by Commonality">
    <p class="max-w-lg mx-auto mt-4 text-sm font-light leading-tight text-gray-600">
      Below is a list of triads and their relationship with the root major chord. (CT - common tone,
      i.e. a tone found in the root chord, DT - diatonic tone, i.e. a tone found in the root key
      major scale).
    </p>

    <div v-if="scaleType === 'major'" class="max-w-xl mx-auto">
      <table class="w-full mx-auto mt-4 font-serif table-auto">
        <thead>
          <tr>
            <th colspan="2" class="px-4 py-2 text-xs font-bold uppercase">Chord</th>
            <th class="px-4 py-2 text-xs font-bold uppercase">CT</th>
            <th class="px-4 py-2 text-xs font-bold uppercase">DT</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="px-4 py-2 text-gray-600 border">I</td>
            <td class="px-4 py-2 font-bold border">
              {{ majorScale.notes()[0].chord().name.replace("b", "&flat;").replace("#", "&sharp;") }}
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">&mdash;</td>
            <td class="px-4 py-2 text-center text-gray-600 border">&mdash;</td>
          </tr>
          <tr>
            <td class="px-4 py-2 text-gray-600 border">vi</td>
            <td class="px-4 py-2 font-bold border">
              {{ majorScale.notes()[5].chord("m").name.replace("b", "&flat;").replace("#", "&sharp;").replace("m", minorSymbol) }}
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">2</td>
            <td class="px-4 py-2 text-center text-gray-600 border">1</td>
          </tr>
          <tr class="bg-gray-100">
            <td class="px-4 py-2 text-gray-600 border">ii</td>
            <td class="px-4 py-2 font-bold border">
              {{ majorScale.notes()[2].chord("m").name.replace("b", "&flat;").replace("#", "&sharp;").replace("m", minorSymbol) }}
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">
              2
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">1</td>
          </tr>
          <tr>
            <td class="px-4 py-2 text-gray-600 border">IV</td>
            <td class="px-4 py-2 font-bold border">
              {{ majorScale.notes()[3].chord().name.replace("b", "&flat;").replace("#", "&sharp;") }}
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">1</td>
            <td class="px-4 py-2 text-center text-gray-600 border">2</td>
          </tr>
          <tr class="bg-gray-100">
            <td class="px-4 py-2 text-gray-600 border">V</td>
            <td class="px-4 py-2 font-bold border">
              {{ majorScale.notes()[4].chord().name.replace("b", "&flat;").replace("#", "&sharp;") }}
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">
              1
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">2</td>
          </tr>
          <tr>
            <td class="px-4 py-2 text-gray-600 border">iv</td>
            <td class="px-4 py-2 font-bold border">
              {{ majorScale.notes()[3].chord("m").name.replace("b", "&flat;").replace("#", "&sharp;").replace("m", minorSymbol) }}
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">1</td>
            <td class="px-4 py-2 text-center text-gray-600 border">1</td>
          </tr>
          <tr class="bg-gray-100">
            <td class="px-4 py-2 text-gray-600 border">ii</td>
            <td class="px-4 py-2 font-bold border">
              {{ majorScale.notes()[1].chord("m").name.replace("b", "&flat;").replace("#", "&sharp;").replace("m", minorSymbol) }}
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">
              0
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">3</td>
          </tr>
          <tr>
            <td class="px-4 py-2 text-gray-600 border">v</td>
            <td class="px-4 py-2 font-bold border">
              {{ majorScale.notes()[4].chord("m").name.replace("b", "&flat;").replace("#", "&sharp;").replace("m", minorSymbol) }}
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">1</td>
            <td class="px-4 py-2 text-center text-gray-600 border">1</td>
          </tr>
          <tr class="bg-gray-100">
            <td class="px-4 py-2 text-gray-600 border">VI</td>
            <td class="px-4 py-2 font-bold border">
              {{ majorScale.notes()[5].chord().name.replace("b", "&flat;").replace("#", "&sharp;") }}
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">
              1
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">1</td>
          </tr>
          <tr>
            <td class="px-4 py-2 text-gray-600 border">III</td>
            <td class="px-4 py-2 font-bold border">
              {{ majorScale.notes()[2].chord().name.replace("b", "&flat;").replace("#", "&sharp;") }}
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">1</td>
            <td class="px-4 py-2 text-center text-gray-600 border">1</td>
          </tr>
          <tr class="bg-gray-100">
            <td class="px-4 py-2 text-gray-600 border">&flat;VI</td>
            <td class="px-4 py-2 font-bold border">
              {{
                majorScale
                  .notes()[0]
                  .interval("m6")
                  .chord().name.replace("b", "&flat;").replace("#", "&sharp;")
              }}
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">
              1
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">0</td>
          </tr>
          <tr>
            <td class="px-4 py-2 text-gray-600 border">II</td>
            <td class="px-4 py-2 font-bold border">
              {{ majorScale.notes()[1].chord().name.replace("b", "&flat;").replace("#", "&sharp;") }}
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">0</td>
            <td class="px-4 py-2 text-center text-gray-600 border">2</td>
          </tr>
          <tr class="bg-gray-100">
            <td class="px-4 py-2 text-gray-600 border">&flat;VII</td>
            <td class="px-4 py-2 font-bold border">
              {{
                majorScale
                  .notes()[0]
                  .interval("m7")
                  .chord().name.replace("b", "&flat;").replace("#", "&sharp;")
              }}
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">
              0
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">2</td>
          </tr>
          <tr>
            <td class="px-4 py-2 text-gray-600 border">vii</td>
            <td class="px-4 py-2 font-bold border">
              {{ majorScale.notes()[6].chord("m").name.replace("b", "&flat;").replace("#", "&sharp;").replace("m", minorSymbol) }}
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">0</td>
            <td class="px-4 py-2 text-center text-gray-600 border">2</td>
          </tr>
          <tr class="bg-gray-100">
            <td class="px-4 py-2 text-gray-600 border">&flat;III</td>
            <td class="px-4 py-2 font-bold border">
              {{
                majorScale
                  .notes()[0]
                  .interval("m3")
                  .chord().name.replace("b", "&flat;").replace("#", "&sharp;")
              }}
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">
              1
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">0</td>
          </tr>
          <tr>
            <td class="px-4 py-2 text-gray-600 border">&sharp;i</td>
            <td class="px-4 py-2 font-bold border">
              {{
                majorScale
                  .notes()[0]
                  .interval("m2")
                  .enharmonics()[0]
                  .chord("m").name.replace("b", "&flat;").replace("#", "&sharp;").replace("m", minorSymbol)
              }}
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">1</td>
            <td class="px-4 py-2 text-center text-gray-600 border">0</td>
          </tr>
          <tr class="bg-gray-100">
            <td class="px-4 py-2 text-gray-600 border">&flat;II</td>
            <td class="px-4 py-2 font-bold border">
              {{
                majorScale
                  .notes()[0]
                  .interval("m2")
                  .chord().name.replace("b", "&flat;").replace("#", "&sharp;")
              }}
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">
              0
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">1</td>
          </tr>
          <tr>
            <td class="px-4 py-2 text-gray-600 border">&sharp;iv</td>
            <td class="px-4 py-2 font-bold border">
              {{
                majorScale
                  .notes()[0]
                  .interval("A4")
                  .chord("m").name.replace("b", "&flat;").replace("#", "&sharp;").replace("m", minorSymbol)
              }}
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">0</td>
            <td class="px-4 py-2 text-center text-gray-600 border">1</td>
          </tr>
          <tr class="bg-gray-100">
            <td class="px-4 py-2 text-gray-600 border">&flat;vi</td>
            <td class="px-4 py-2 font-bold border">
              {{
                majorScale
                  .notes()[0]
                  .interval("m6")
                  .chord("m").name.replace("b", "&flat;").replace("#", "&sharp;").replace("m", minorSymbol)
              }}
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">
              0
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">1</td>
          </tr>
          <tr>
            <td class="px-4 py-2 text-gray-600 border">&flat;vii</td>
            <td class="px-4 py-2 font-bold border">
              {{
                majorScale
                  .notes()[0]
                  .interval("m7")
                  .chord("m").name.replace("b", "&flat;").replace("#", "&sharp;").replace("m", minorSymbol)
              }}
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">0</td>
            <td class="px-4 py-2 text-center text-gray-600 border">1</td>
          </tr>
          <tr class="bg-gray-100">
            <td class="px-4 py-2 text-gray-600 border">VII</td>
            <td class="px-4 py-2 font-bold border">
              {{ majorScale.notes()[6].chord().name.replace("b", "&flat;").replace("#", "&sharp;") }}
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">
              0
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">1</td>
          </tr>
          <tr>
            <td class="px-4 py-2 text-gray-600 border">&flat;iii</td>
            <td class="px-4 py-2 font-bold border">
              {{
                majorScale
                  .notes()[0]
                  .interval("m3")
                  .chord("m").name.replace("b", "&flat;").replace("#", "&sharp;").replace("m", minorSymbol)
              }}
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">0</td>
            <td class="px-4 py-2 text-center text-gray-600 border">0</td>
          </tr>
          <tr class="bg-gray-100">
            <td class="px-4 py-2 text-gray-600 border">&flat;V</td>
            <td class="px-4 py-2 font-bold border">
              {{
                majorScale
                  .notes()[0]
                  .interval("A4")
                  .enharmonics()[0]
                  .chord().name.replace("b", "&flat;").replace("#", "&sharp;")
              }}
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">
              0
            </td>
            <td class="px-4 py-2 text-center text-gray-600 border">0</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="mt-4 italic text-center" v-else>
      <p>Chord list for {{scaleType.replace("_", " ")}} coming soon!</p>
    </div>
  </Panel>
</template>

<script>
import Panel from "../components/Panel.vue";
import teoria from "teoria";
const note = teoria.note;
const scale = teoria.scale;

export default {
  props: {
    rootNote: String,
    minorSymbol: String,
    scaleType: String
  },
  components: { Panel },
  computed: {
    majorScale() {
      return scale(note(this.rootNote), "major");
    }
  }
};
</script>
